import Layout from '@layouts/Layout';
import AboutUs from '@screens/Company/AboutUs';

import React, { memo } from 'react';

const title = 'About us';
const description = 'Traqq helps businesses and organizations track the work time of their teams, monitor activities, and simplify calculating payroll. Works for freelancers too!';

const AboutPage = () => (
    <Layout
        title={ title }
        description={ description }
        useTemplate
    >
        <AboutUs />
    </Layout>
);

export default memo(AboutPage);
